import React, { useEffect } from "react";
import { Card, Alert, Button, Container } from "react-bootstrap";
import LoadingLoginScreen from "../../../components/LoadingLoginScreen";
import { EditLeadAsAdminModal } from '../EditLeadAsAdminModal'
import { formatText } from '../../../components/CONSTANTS'

import { getLeadAPI } from "../../../services/Leadservice";
import { useHistory } from "react-router-dom";
import { removeLead } from "../../../services/AdminService";
/*
AdminLeadDetails
*/
export const AdminLeadDetails = ({ match }) => {

    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState(false);
    const [errorType, setErrorType] = React.useState("primary");

    const [lead, setLead] = React.useState({});

    let timer;

    useEffect(() => {
        setLoading(true);
        setError(true);
        setErrorText(`Behandla lead ${match.params.id}`)

        const getLead = async () => {
            setLead(await getLeadAPI(match.params.id))
        }

        getLead().then(() => {
            setErrorText(`Hämtade lead ${match.params.id}`);
            setErrorType("success")
        }).finally(() => {
            timer = setTimeout(() => {
                setError(false)
            }, 5000)
        })
        setLoading(false);
        clearTimeout(timer);
    }, []);

    let history = useHistory();

    const handleEditLead = async () => {

    }

    const handleRemoveLead = async () => {


        try {


            await removeLead(match.params.id).then(() => {
                setLoading(true);

                setErrorText("Lead borttagen");

                timer = setTimeout(() => {

                    setLoading(false);
                    history.goBack();

                }, 500)
            });
        } catch {
            setError(true);
            setErrorText("Fel uppstod");
        }


        setLoading(false);
    }

    return (
        <Container >
            {loading ? <LoadingLoginScreen /> :
                <Container >

                    {error ? <Alert variant={errorType}>
                        {errorText}
                    </Alert> : null}
                    <Card>
                        <Card.Header>Kund: </Card.Header>
                        <Card.Body>
                            {lead.firstname} {lead.lastname}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>Kundemail:</Card.Header>
                        <Card.Body>
                            {lead.email}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>Dealstage:</Card.Header>
                        <Card.Body>
                            {formatText(lead.dealstage)}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>PandadocID:</Card.Header>
                        <Card.Body>
                            {lead.pandadocID}
                        </Card.Body></Card>
                    <Card>
                        <Card.Header>Referens:</Card.Header>
                        <Card.Body>
                            {lead.reference}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>Företag:</Card.Header>
                        <Card.Body>
                            {lead.company}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>Referensadmin:</Card.Header>
                        <Card.Body>
                            {lead.referenceAdmin}
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header>Hantera Lead</Card.Header>
                        <Card.Body>
                            <EditLeadAsAdminModal
                                leadnumber={match.params.id}
                                pandadocID={lead.pandadocID}
                                referenceadmin={lead.reference}
                                email={lead.email}
                                firstName={lead.firstname}
                                lastName={lead.lastname}
                                loading={loading} />
                            <Button disabled={loading} onClick={() =>
                                handleRemoveLead()
                            } variant={"danger"}>
                                Ta bort lead
                            </Button>
                        </Card.Body>
                    </Card>
                </Container>
            }
        </Container>

    )
}
